module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [(_vm.mode === 1) ? _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('a', {
    staticClass: "pull-right btn btn-success btn-sm btn-branch",
    attrs: {
      "exact": ""
    },
    on: {
      "click": function($event) {
        _vm.mode = 3
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" New\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.entities.length),
      expression: "entities.length"
    }],
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.publish_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.unpublish_date))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.editItem(item)
        }
      }
    }, [_vm._v("\n                        Edit\n                      ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'announcements/', 'Announcement')
        }
      }
    }, [_vm._v("\n                        Delete\n                        "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1)])
  }), 0)]), _vm._v(" "), (!_vm.entities.length) ? _c('div', {
    staticClass: "text-center mt-2"
  }, [_c('strong', [_vm._v("There are no announcements yet")])]) : _vm._e()])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.mode === 2) ? _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm mt-0 btn-branch",
    on: {
      "click": function($event) {
        _vm.mode = 1
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v("\n              Back\n            ")])])]), _vm._v(" "), _c('edit', {
    attrs: {
      "item-to-edit": _vm.itemToEdit
    },
    on: {
      "changeMode": _vm.setMode
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.mode === 3) ? _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('a', {
    staticClass: "btn btn-success btn-sm btn-branch",
    on: {
      "click": function($event) {
        _vm.mode = 1
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" Back\n            ")])])]), _vm._v(" "), _c('new', {
    on: {
      "changeModeOnCreate": _vm.setModeOnCreate
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Publish_date")]), _vm._v(" "), _c('th', [_vm._v("Unpublish date")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51aa48f0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/branchOffices/sections/announcements/Index.vue
// module id = 901
// module chunks = 0